export default function Error() {
  return (
    <div className='bg-gray-200 p-6 rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-lg'>
      <h1 className='text-2xl font-bold mb-2'>에러가 발생했습니다.</h1>
    </div>
  );
}
